<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>





        <v-card class="box">
            <v-data-table :headers="headers" :items="constraint_list" class="elevation-1 mytable" dense sort-by="srno"
                :search="search">
                <template v-slot:top>

                    <div class="d-flex justify-end">
                        <v-btn class="mt-2" color="primary" rounded @click="add_new_installment"
                            :loading="fetch_btn_load">+ Add Constraint </v-btn>
                        <v-col sm="1" md="1" cols="4">
                            <v-btn class="mt-0" color="success" dark @click="exportFilteredData" outlined
                                :loading="loader" block>
                                <v-icon small color="success">mdi-export</v-icon>
                                Export
                            </v-btn>
                        </v-col>
                    </div>


                    <span style="width: 20px;"> </span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="8" cols="12"> </v-col>
                        <v-col sm="6" md="6" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                        </v-col>
                        <span style="width: 20px;"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field v-model="editedItem.name" persistent-hint
                                                        label="Enter Name "> </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field v-model="editedItem.code" persistent-hint
                                                        label="Enter Code "> </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-text-field v-model="editedItem.description" persistent-hint
                                                        label="Enter Description "> </v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="4">
                                                    <v-checkbox dense v-model="editedItem.hardConstraint"
                                                        color="success" label="Is Hard Constraint"> </v-checkbox>
                                                </v-col>
                                            </v-row>

                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" color="primary" @click="save"
                                            :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>
                <!-- <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                        <v-avatar size="32" class="mr-2" color="red lighten-4">
                            <v-icon small @click="deleteItem(item)" color="error">mdi-delete</v-icon>
                        </v-avatar>

                    </div>
                </template> -->
                <!-- <template v-slot:item.isactive="{ item }">
                    <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
                        @change="toggle(item)"></v-switch>
                </template> -->
                <template v-slot:item.hardConstraint="{ item }">
                    <span v-if="item.hardConstraint">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>

                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>
                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar mr-2">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)" color="success">edit</v-icon>
                        </v-avatar>
                    </div>
                </template>
                <template v-slot:item.actionnew="{ item }">
                    <div>
                        <v-avatar size="32" class="mr-2" color="red lighten-4">
                            <v-icon small @click="deleteItem(item)" color="error">mdi-delete</v-icon>
                        </v-avatar>
                    </div>
                </template>
            </v-data-table>
        </v-card>
        <!-- edit dialog  -->
        <v-dialog v-model="edit_dialog" max-width="700px">
            <v-card>
                <v-form v-model="valid">
                    <v-card-title class="toolbar">
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field v-model="editedItem.name" persistent-hint label="Enter Name ">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field v-model="editedItem.code" persistent-hint label="Enter Code ">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field v-model="editedItem.description" persistent-hint
                                        label="Enter Description "> </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="4">
                                    <v-checkbox dense v-model="editedItem.hardConstraint" color="success"
                                        label="Is Hard Constraint"> </v-checkbox>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                        <v-btn class="mb-2 button" color="primary" @click="save_edited" :disabled="!valid">Save</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
    import axios from "axios";
    export default {
        data: () => ({
            valid: false,
            overlay: false,
            errorMsg: {
                name: false,
            },
            snackbar_msg: "",
            // extraBreadcrumbItems: [
            //     { text: "Time Table Constraint Master", disabled: true, href: "" },

            // ],
            // breadcrumbClass: "breadcrumb-style2",
            color: "",
            snackbar: false,
            overlay: false,
            search: "",
            dialog: false,
            headers: [
                { text: "Sr. No.", value: "srno" },
                {
                    text: "Name",
                    align: "left",
                    sortable: false,
                    value: "name",
                },
                {
                    text: "Code",
                    align: "left",
                    sortable: false,
                    value: "code",
                },
                {
                    text: "Description",
                    align: "left",
                    sortable: false,
                    value: "description",
                },
                {
                    text: "Is Hard Constraint",
                    align: "left",
                    sortable: false,
                    value: "hardConstraint",
                },
                { text: "Edit", value: "action", sortable: false },
                { text: "Delete", value: "actionnew", sortable: false },
            ],
            constraint_list: [],
            editedIndex: -1,
            editedItem: {
                id: "",
                name: "",
                description: "",
                code: "",
                hardConstraint: true,
            },
            defaultItem: {
                id: "",
                name: "",
                description: "",
                code: "",
                hardConstraint: true,
            },
        }),
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Add Time Table Constraint" : "Edit Time Table Constraint";
            },
        },
        watch: {
            dialog(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        mounted() {
            this.onLoad();
        },
        methods: {

            exportFilteredData() {

                const exportData = this.constraint_list.map(item => ({
                    "Sr. No.": item.srno,
                    "Name": item.name,
                    "Code": item.code,
                    "Description": item.description || "-",
                    "Is Hard Constraint": item.hardConstraint ? "Yes" : "No"
                }));


                import("xlsx").then(XLSX => {
                    const worksheet = XLSX.utils.json_to_sheet(exportData);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "TimeTableConstraint");
                    XLSX.writeFile(workbook, "TimeTableConstraint.xlsx");
                });
            },


            add_new_installment() {
                this.dialog = true;
            },
            close() {
                this.dialog = false;
                this.edit_dialog = false;
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            editItem(item) {
                // alert("editItem: " + JSON.stringify(item));
                this.editedIndex = this.constraint_list.indexOf(item);
                this.editedItem = {
                    id: item.id,
                    name: item.name,
                    code: item.code,
                    description: item.description,
                    hardConstraint: item.hardConstraint,
                    // ✅ Only the ID
                };
                this.edit_dialog = true;
            },
            close() {
                this.dialog = false;
                this.edit_dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },
            onLoad() {
                this.overlay = true;
                axios
                    .post("/AITimeTable/addTimeTableConstraint")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.overlay = false;
                            // this.constraint_list = res.data.constraint_list;
                            // srno: index + 1
                            this.constraint_list = res.data.constraint_list.map((item, index) => ({
                                ...item,
                                srno: index + 1
                            }));
                        } else {
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something  Went Wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        "use strict";
                        var overlay = false;
                    });
            },
            save() {
                if (!this.editedItem.name || this.editedItem.name.trim() === "") {
                    this.showSnackbar("#b71c1c", "Constraint Name is required.");
                    return;
                }

                if (!this.editedItem.code || this.editedItem.code.trim() === "") {
                    this.showSnackbar("#b71c1c", "Constraint Code is required.");
                    return;
                }
                const data = {
                    code: this.editedItem.code,
                    description: this.editedItem.description,
                    name: this.editedItem.name,
                    hardConstraint: this.editedItem.hardConstraint ,

                };
                axios
                    .post("/AITimeTable/saveTimeTableConstraint", data)
                    .then((res) => {
                        if (res.data.status === "YES") {
                            this.showSnackbar("#4caf50", "TimeTableConstraint Added Successfully..."); // show snackbar on success
                            this.onLoad();

                        } else {
                            this.showSnackbar("#b71c1c", "TimeTableConstraint Already Present!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
                this.close();
            },
            save_edited() {
                if (!this.editedItem.name || this.editedItem.name.trim() === "") {
                    this.showSnackbar("#b71c1c", "Constraint Name is required.");
                    return;
                }

                if (!this.editedItem.code || this.editedItem.code.trim() === "") {
                    this.showSnackbar("#b71c1c", "Constraint Code is required.");
                    return;
                }
                // alert("save-----" + this.editedItem.id)
                const data = {
                    data: this.editedItem,
                    code: this.editedItem.code,
                    description: this.editedItem.description,
                    name: this.editedItem.name,
                    hardConstraint: this.editedItem.hardConstraint ,
                    editid: this.editedItem.id,

                };
                axios
                    .post("/AITimeTable/editTimeTableConstraint", data)
                    .then((res) => {
                        if (res.data.status === "YES") {
                            this.showSnackbar("#4caf50", "TimeTableConstraint Updated Successfully..."); // show snackbar on success
                            this.onLoad();

                        } else {
                            this.showSnackbar("#b71c1c", "TimeTableConstraint Already Present!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
                this.close();
            },
            deleteItem(item) {

                // Optional: confirm before deleting
                if (!confirm("Are you sure you want to delete this record?")) return;

                this.overlay = true;
                axios
                    .post("/AITimeTable/deleteTimeTableConstraint", {
                        id: item.id
                    })
                    .then((res) => {
                        if (res.data.status === "YES") {
                            this.showSnackbar("#4caf50", "Time Table Constraint Deleted successfully!");
                            this.onLoad(); // Refresh the table

                        } else {
                            this.showSnackbar("#b71c1c", "Delete failed.");
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        this.showSnackbar("#b71c1c", "Something went wrong.");
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },




        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }

    .v-icon-size {
        font-size: 20px;
    }

    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }

    .edit-avatar:hover {
        background-color: #b0bec5;
    }

    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }

    .edit-v-icon:hover {
        color: white;
    }
</style>